import React from 'react';
import styled from '@emotion/styled';
import {
  alignItems,
  border,
  borderTop,
  display,
  justifyContent,
  space,
  width,
} from 'styled-system';

import { Button } from '../../components/Button';
import { useLocalization } from '../../providers/LocaleProvider';
import { borderTopColor, borderTopStyle, borderTopWidth } from '../../theme/system-utilities';
import { BodyRegularBR1 } from '../Typography';
import ArrowIcon from './ArrowIcon';

interface ToggleButtonProps {
  isCollapsed: boolean;
  onClick: () => void;
  ariaControls: string;
}

const StyledButton = styled(Button)<any>`
  ${alignItems};
  ${border};
  ${borderTopStyle};
  ${borderTopWidth};
  ${borderTopColor};
  ${borderTop};
  ${display};
  ${justifyContent};
  ${space};
  ${width};

  cursor: pointer;
`;

const styledButtonStyles = {
  type: 'button',
  kind: 'bare',
  alignItems: 'center',
  border: 'none',
  borderTopStyle: 'solid',
  borderTopWidth: 'small',
  borderTopColor: 'sys.neutral.border.weak',
  display: 'flex',
  justifyContent: 'space-between',
  pt: ['sp_12', null, null, 'sp_16'],
  width: 1,
};

const ButtonLabel = styled(BodyRegularBR1)<any>`
  cursor: pointer;
`;

const ToggleButton = ({ isCollapsed, ariaControls, onClick }: ToggleButtonProps) => {
  const { t } = useLocalization();

  return (
    <StyledButton
      onClick={onClick}
      aria-expanded={!isCollapsed}
      aria-controls={ariaControls}
      {...styledButtonStyles}
    >
      <ButtonLabel>{t('h24_next_steps')}</ButtonLabel>
      <ArrowIcon isCollapsed={isCollapsed} />
    </StyledButton>
  );
};

export default ToggleButton;
